import { lazy } from "react";
import IRoute from "./IRoute";

const LearnPage = lazy(() => import("../pages/Learn/LearnPage"));

const learnRoutes: IRoute = {
  path: "/learn",
  component: LearnPage,
  needAuth: true,
};

export default learnRoutes;
